"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThirdPartyProductType = void 0;
/**
 * Canonical set of third-party products that Aven supports across leads, pricing, and attribution flows.
 * These values must remain stable because they are persisted in Postgres and referenced by external partners.
 */
var ThirdPartyProductType;
(function (ThirdPartyProductType) {
    ThirdPartyProductType["HOME_EQUITY_CASH"] = "homeEquityCash";
    ThirdPartyProductType["HOME_EQUITY_CARD"] = "homeEquityCard";
    ThirdPartyProductType["PERSONAL_LOAN"] = "personalLoan";
    ThirdPartyProductType["MORTGAGE_CONVENTIONAL"] = "mortgageConventional";
    ThirdPartyProductType["FIRST_LIEN_HELOC"] = "firstLienHeloc";
    ThirdPartyProductType["REWARDS_CARD"] = "rewardsCard";
})(ThirdPartyProductType || (exports.ThirdPartyProductType = ThirdPartyProductType = {}));
